// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-BE';

import resetPassword from './resetPassword';

resetPassword(i18n);
